import React, { useEffect } from "react";
import { Col, Row, Form, Tooltip, Select, Button } from "antd";
import { SkillService } from "@frontend/src/core/services/skill_service";
import { useState } from "react";

const SkillFields = ({ remove, id, form, initialValues, readonly=false }) => {
  const [skills, setSkills] = useState([]);
  const [value, setValue] = useState(undefined);
  const skillService = new SkillService();
  const { getFieldDecorator } = form;

  useEffect(() => {
    fetchSkills("");
  }, []);

  const onSearchSkills = (value) => {
    fetchSkills(value);
  };

  const onChangeValue = (value) => {
    setValue(value);
  };

  const fetchSkills = (query) => {
    const filters = {
      q: {
        g: [
          {
            m: "or",
            id_in: initialValues?.id,
            description_cont: query,
          },
        ],
      },
    };

    skillService.getSkills(
      filters,
      (data) => {
        setSkills(data);
      },
      (error) => console.log(error)
    );
  };

  return (
    <>
      <Row>
        <Col xs={{ span: 12 }}>
          <Form.Item label={`Seleccione una habilidad`}>
            {getFieldDecorator(`skill[${id}]`, {
              initialValue: initialValues?.id,
              rules: [{ required: true, message: "El campo es requerido." }],
            })(
              <Select
                showSearch
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Buscar tipo de habilidad"
                initialValue={initialValues?.id}
                onSearch={onSearchSkills}
                onChange={onChangeValue}
                filterOption={(input, option) =>
                  option.props.children.includes(input)
                }
                disabled={readonly == true}
              >
                {skills.map((item) => (
                  <Select.Option
                    key={item.id}
                    value={item.id}
                    label={`${item.description}` || ""}
                  >
                    {item.description}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col style={{ top: 60 }} xs={{ span: 1, offset: 11 }}>
          <Tooltip title="Quitar opción">
            <Button
              className="delete-button"
              icon="delete"
              onClick={() => remove(id)}
              disabled={readonly == true}
            />
          </Tooltip>
        </Col>
      </Row>
    </>
  );
};

export default SkillFields;
